import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { useAccountSettingsLayout } from "@pages/account-settings/account-settings-layout/account-settings-layout-utils";
/** Shows a static text that is not possible to change */
export function AccountReadOnlyText(t0) {
  const $ = _c(9);
  const {
    text,
    shouldPreventTranslation: t1
  } = t0;
  const shouldPreventTranslation = t1 === undefined ? false : t1;
  const {
    accountSettingsFontSize,
    accountSettingsFontWeight
  } = useAccountSettingsLayout();
  let t2;
  if ($[0] !== accountSettingsFontSize || $[1] !== accountSettingsFontWeight) {
    t2 = {
      fontSize: accountSettingsFontSize,
      fontWeight: accountSettingsFontWeight
    };
    $[0] = accountSettingsFontSize;
    $[1] = accountSettingsFontWeight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== shouldPreventTranslation || $[4] !== text) {
    t3 = shouldPreventTranslation ? <var>{text}</var> : text;
    $[3] = shouldPreventTranslation;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Text variant="bodyM" sx={t2}>{t3}</Text>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}